/**
 * Pet profile removal reason identifiers for BFF `removalReasonId` (pet status updates).
 * Values must match Profile API pet removal master data.
 * Master id 3 is the generic / “unknown” bucket (multiple UI reasons map here).
 */
export enum PetRemovalReasonId {
    NoLongerLivesWithMe = 1,
    PetPassedAway = 2,
    Unknown = 3,
    /** Same master id as Unknown (legacy name). */
    CreatedByMistake = Unknown,
    Other = 4,
}
